// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import config from './utils/config';
import store from './store'
import apis from './utils/apis';
import VueRouter from   'vue-router'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { getToken } from './utils/auth'
import "@/assets/css/commom.css";
import './assets/iconfont/iconfont.css'

axios.interceptors.request.use(
  cfg =>{
    let token = getToken();
    if(token){
      //这里面获取的请求头的键(tokenHeader)根据每个后端的习惯封装的名称各不相同  
      cfg.headers.common['appToken'] = config.appId;
      cfg.headers.common[config.tokenKey] = token;
      cfg.headers.common['Content-Type'] = 'application/json';
    }
    return cfg
  }, error =>{
    return Promise.reject(error)
  }
);

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue();
Vue.prototype.$apis = apis;
Vue.use(VueRouter);
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  router,
  store,
  components: { App },
  template: '<App/>',
  beforeCreate(){
		Vue.prototype.$axios = axios
	}
});





// WEBPACK FOOTER //
// ./src/main.js